// TODO(dev:dashboard_v2, translations): Add missing translations
export class GreetingHelper {
  /**
   * Returns a time-based greeting with the user's name based on the current device time
   * @param name - The user's name (or fallback like "there")
   * @returns Complete greeting like "Good morning, John!" or "Good afternoon, there!"
   */
  static getGreeting(name: string): string {
    const now = new Date()
    const hour = now.getHours()

    let greeting = ""

    // 5am to 12pm (5:00 - 11:59) -> Good morning
    if (hour >= 5 && hour < 12) {
      greeting = "Good morning,"
    }
    // 12pm to 7pm (12:00 - 18:59) -> Good afternoon
    else if (hour >= 12 && hour < 19) {
      greeting = "Good afternoon,"
    }
    // 7pm to 5am (19:00 - 4:59) -> Good evening
    else {
      greeting = "Good evening,"
    }

    return `${greeting} ${name}!`
  }
}
